import { NgModule } from 'ng-metadata/core';
import { OrderSummaryComponent } from './order-summary.component';

@NgModule({
  declarations: [OrderSummaryComponent],
})
export class OrderSummaryModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/order-summary/order-summary.module.ts